import {useEffect, useState} from 'react';
import {Button, Input, Typography} from 'antd';
import DBModal from 'components/modal/modal';
import styles from './kycHub.module.scss';

const {Text} = Typography;

/** Asks for the required reason behind archiving a document or a note. */
export const ReasonModal = ({
  open,
  title,
  subtitle,
  description,
  placeholder,
  confirmLabel,
  submitting,
  onClose,
  onSubmit,
}) => {
  const [reason, setReason] = useState('');
  const [touched, setTouched] = useState(false);

  useEffect(() => {
    if (open) {
      setReason('');
      setTouched(false);
    }
  }, [open]);

  const missing = !reason.trim();

  const handleSubmit = () => {
    setTouched(true);
    if (!missing) onSubmit(reason.trim());
  };

  return (
    <DBModal
      isOpen={open}
      handleClose={onClose}
      width={480}
      destroyOnClose
      content={
        <div className={styles.modalBody}>
          <h2 className={styles.modalTitle}>{title}</h2>
          {subtitle && <Text type="secondary">{subtitle}</Text>}
          <Text className={styles.modalField}>{description}</Text>

          <div className={styles.modalField}>
            <label className={styles.fieldLabel} htmlFor="kyc-hub-reason">
              Reason (required)
            </label>
            <Input.TextArea
              id="kyc-hub-reason"
              rows={3}
              value={reason}
              maxLength={1000}
              showCount
              placeholder={placeholder}
              onChange={event => setReason(event.target.value)}
            />
            {touched && missing && (
              <Text type="danger" className={styles.fieldError}>
                Give a reason.
              </Text>
            )}
          </div>

          <div className={styles.modalActions}>
            <Button onClick={onClose}>Cancel</Button>
            <Button
              type="primary"
              danger
              loading={submitting}
              onClick={handleSubmit}>
              {confirmLabel}
            </Button>
          </div>
        </div>
      }
    />
  );
};
